import { useContext, useState } from "react";
import api from "../../api";
import { useToast } from "../ToastContext";
import { LoadingContext } from "../LoadingContext";
import { AuthContext } from "../AuthContext";
import { set } from "lodash";

export interface PreparacaoAlbumType {
    id: number
    description?: string;
    numberOfPhotos?: number;
    numberOfPhotosLaboratory?: number;
    numberOfAlbums?: number;
    editorDeliveryDate?: string;
    editorReturnDate?: string;
    laboratoryDeliveryDate?: string;
    laboratoryReturnDate?: string;
    kit30x60?: boolean;
    kit30x60Quantities?: number;
    kit10x15?: boolean;
    kit10x15Quantities?: number;
    kit28x35?: boolean;
    kit28x35Quantities?: number;
    status?: number;
    empresaId: number;
    contratoId: number;
    editorId?: number;
    editorName?: string;
    laboratorioId?: number;
    laboratoryName?: string;
    conferenteId?: number;
    conferenteName?: string;
    cursos?: {
        id: number;
        name: string;
        empresaId: number;
    }[];
}

export interface CreatePreparacaoAlbumType {
    description?: string;
    numberOfPhotos?: number;
    numberOfPhotosLaboratory?: number;
    numberOfAlbums?: number;
    editorDeliveryDate?: string;
    editorReturnDate?: string;
    laboratoryDeliveryDate?: string;
    laboratoryReturnDate?: string;
    kit30x60?: boolean;
    kit30x60Quantities?: number;
    kit10x15?: boolean;
    kit10x15Quantities?: number;
    kit28x35?: boolean;
    kit28x35Quantities?: number;
    status?: number;
    empresaId: number;
    contratoId: number;
    editorId?: number;
    laboratorioId?: number;
    conferenteId?: number;
    cursoId?: number[];
}

export interface EditPreparacaoAlbumType {
    id: number;
    description?: string;
    numberOfPhotos?: number;
    numberOfPhotosLaboratory?: number;
    numberOfAlbums?: number;
    editorDeliveryDate?: string;
    editorReturnDate?: string;
    laboratoryDeliveryDate?: string;
    laboratoryReturnDate?: string;
    kit30x60?: boolean;
    kit30x60Quantities?: number;
    kit10x15?: boolean;
    kit10x15Quantities?: number;
    kit28x35?: boolean;
    kit28x35Quantities?: number;
    status?: number;
    empresaId: number;
    contratoId: number;
    editorId?: number;
    laboratorioId?: number;
    conferenteId?: number;
    cursos?: {
        id: number;
        name: string;
        empresaId: number;
    }[];
}

export default function usePreparacaoAlbum() {
    const showToast = useToast();
    const { setLoading } = useContext(LoadingContext);
    const { handleLogout, objUserTk } = useContext(AuthContext);
    const [listPreparacaoAlbum, setListPreparacaoAlbum] = useState<PreparacaoAlbumType[]>([]);
    const [preparacaoAlbumPageCount, setPreparacaoAlbumPageCount] = useState<number>(0);
    const [initialListPreparacaoAlbum, setInitialListPreparacaoAlbum] = useState<PreparacaoAlbumType[]>([]);
    const [preparacaoAlbum, setPreparacaoAlbum] = useState<PreparacaoAlbumType>({
        id: 0,
        description: "",
        numberOfPhotos: 0,
        numberOfPhotosLaboratory: 0,
        numberOfAlbums: 0,
        editorDeliveryDate: "",
        editorReturnDate: "",
        laboratoryDeliveryDate: "",
        laboratoryReturnDate: "",
        kit30x60: false,
        kit30x60Quantities: 0,
        kit10x15: false,
        kit10x15Quantities: 0,
        kit28x35: false,
        status: 0,
        empresaId: 0,
        contratoId: 0,
        editorId: 0,
        editorName: "",
        laboratorioId: 0,
        laboratoryName: "",
        conferenteId: 0,
        conferenteName: "",
    });

    function createPreparacaoAlbum(createPreparacaoAlbumType: CreatePreparacaoAlbumType): Promise<CreatePreparacaoAlbumType | null> {
        setLoading(true);
        console.log("data: ", createPreparacaoAlbumType);
        return api
            .post(`/PreparacaoAlbum/create`, createPreparacaoAlbumType)
            .then((response) => {
                const createdPreparacaoAlbum: CreatePreparacaoAlbumType = response.data;
                showToast("success", "Album criado com sucesso.");
                setLoading(false);
                return createdPreparacaoAlbum;
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    handleLogout();
                    showToast(
                        "error",
                        "Sessão desconectada. Favor login novamente.",
                        error
                    );
                } else {
                    showToast(
                        "error",
                        "Erro ao criar album. Verifique novamente mais tarde.",
                        error
                    );
                }
                setLoading(false);
                console.error("Erro ao criar album:", error);
                return null;
            });
    }

    function getPreparacaoAlbumPaged(
        pageNumber: number,
        EmpresaId?: number,
        ContratoId?: number,
        pageSize?: number,
        EditorId?: number,
        LaboratorioId?: number,
        Status?: number,
        InitialDate?: string,
        FinalDate?: string,
    ): Promise<PreparacaoAlbumType[] | null> {
        setLoading(true);
        let url = `/PreparacaoAlbum/getPreparacaoAlbumPaged?pageNumber=${pageNumber}&pageSize=${pageSize}`;

        if (EmpresaId) {
            url += `&EmpresaId=${EmpresaId}`;
        }

        if (ContratoId) {
            url += `&ContratoId=${ContratoId}`;
        }

        if (EditorId) {
            url += `&EditorId=${EditorId}`;
        }

        if (LaboratorioId) {
            url += `&LaboratorioId=${LaboratorioId}`;
        }

        if (Status) {
            url += `&Status=${Status}`;
        }

        if (InitialDate) {
            url += `&InitialDate=${InitialDate}`;
        }

        if (FinalDate) {
            url += `&FinalDate=${FinalDate}`;
        }

        return api
            .get(url)
            .then((response) => {
                setListPreparacaoAlbum(response.data.result);
                setInitialListPreparacaoAlbum(response.data.result);
                setPreparacaoAlbumPageCount(response.data.pageCount);
                console.log(listPreparacaoAlbum);
                setLoading(false);
                return response.data.result;
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    handleLogout();
                    showToast(
                        "error",
                        "Sessão desconectada. Favor login novamente.",
                        error
                    );
                } else {
                    showToast(
                        "error",
                        "Erro ao carregar lista de albuns. Verifique novamente mais tarde.",
                        error
                    );
                }
                setLoading(false);
                console.error("Erro ao carregar lista de alguns:", error);
                return null;
            });
    }

    function updatePreparacaoAlbum(updatePreparacaoAlbumData: EditPreparacaoAlbumType): Promise<EditPreparacaoAlbumType | null> {
        setLoading(true);
        return api
            .put(`/PreparacaoAlbum/${updatePreparacaoAlbumData.id}`, updatePreparacaoAlbumData)
            .then((response) => {
                showToast("success", "Album atualizado com sucesso.");
                setLoading(false);
                return response.data;
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    handleLogout();
                    showToast(
                        "error",
                        "Sessão desconectada. Favor login novamente.",
                        error
                    );
                } else {
                    showToast(
                        "error",
                        "Erro ao atualizar album. Verifique novamente mais tarde.",
                        error
                    );
                }
                setLoading(false);
                console.error("Erro ao atualizar album:", error);
                return null;
            });
    }

    function deletePreparacaoAlbum(preparacaoAlbumId: number): Promise<PreparacaoAlbumType | null> {
        setLoading(true);
        return api
            .delete(`/PreparacaoAlbum/${preparacaoAlbumId}`)
            .then(() => {
                setPreparacaoAlbum({
                    id: 0,
                    description: "",
                    numberOfPhotos: 0,
                    numberOfPhotosLaboratory: 0,
                    numberOfAlbums: 0,
                    editorDeliveryDate: "",
                    editorReturnDate: "",
                    laboratoryDeliveryDate: "",
                    laboratoryReturnDate: "",
                    kit30x60: false,
                    kit30x60Quantities: 0,
                    kit10x15: false,
                    kit10x15Quantities: 0,
                    kit28x35: false,
                    kit28x35Quantities: 0,
                    status: 0,
                    empresaId: 0,
                    contratoId: 0,
                    editorId: 0,
                    editorName: "",
                    laboratorioId: 0,
                    laboratoryName: "",
                });
                showToast("success", "Album deletada com sucesso.");
                setLoading(false);
                return null;
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    handleLogout();
                    showToast(
                        "error",
                        "Sessão desconectada. Favor login novamente.",
                        error
                    );
                } else {
                    showToast(
                        "error",
                        "Erro ao deletar album. Verifique novamente mais tarde.",
                        error
                    );
                }
                setLoading(false);
                console.error("Erro ao deletar album:", error);
                return null;
            });
    }

    function handleGetPreparacaoAlbumById(preparacaoAlbumId: number): Promise<PreparacaoAlbumType | null> {
        setLoading(true);
        return api
            .get(`/PreparacaoAlbum/${preparacaoAlbumId}`)
            .then((response) => {
                const preparacaoAlbum: PreparacaoAlbumType = response.data;
                setPreparacaoAlbum(preparacaoAlbum);
                setLoading(false);
                return preparacaoAlbum;
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    handleLogout();
                    showToast(
                        "error",
                        "Sessão desconectada. Favor login novamente.",
                        error
                    );
                } else {
                    showToast(
                        "error",
                        "Erro ao buscar album pelo ID. Verifique novamente mais tarde.",
                        error
                    );
                }
                setLoading(false);
                console.error("Erro ao buscar album pelo ID:", error);
                return null;
            });
    }

    function updateStatusPreparacaoAlbum(preparacaoAlbumId: number, status: number): Promise<boolean> {
        setLoading(true);

        return api
            .post(`/PreparacaoAlbum/updateStatus/${preparacaoAlbumId}/${status}`)
            .then((response) => {
                showToast("success", "Status do album atualizado com sucesso.");
                setLoading(false);
                return true;
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    handleLogout();
                    showToast("error", "Sessão desconectada. Favor login novamente.", error);
                } else {
                    showToast("error", "Erro ao atualizar status do album. Tente novamente mais tarde.", error);
                }
                setLoading(false);
                console.error("Erro ao atualizar status do album:", error);
                return false;
            });
    }

    function exportPreparacaoAlbumPdf(filters: {
        EmpresaId?: number,
        ContratoId?: number,
        EditorId?: number,
        LaboratorioId?: number,
        Status?: number,
        InitialDate?: string,
        FinalDate?: string,
    }): Promise<void> {
        setLoading(true);
    
        const payload = {
            EmpresaId: filters.EmpresaId,
            ContratoId: filters.ContratoId && filters.ContratoId !== 0 ? filters.ContratoId : null,
            EditorId: filters.EditorId && filters.EditorId !== 0 ? filters.EditorId : null,
            LaboratorioId: filters.LaboratorioId && filters.LaboratorioId !== 0 ? filters.LaboratorioId : null,
            Status: filters.Status && filters.Status !== 0 ? filters.Status : null,
            InitialDate: filters.InitialDate ? filters.InitialDate : null,
            FinalDate: filters.FinalDate ? filters.FinalDate : null,
            pageNumber: 1,
            pageSize: 999999
        };
    
        return api.post(`/PreparacaoAlbum/export/pdf`, payload, {
            responseType: 'blob',
        })
            .then((response) => {
                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'relatorio-preparacoes.pdf');
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
                setLoading(false);
            })
            .catch((error) => {
                showToast("error", "Erro ao exportar o PDF. Tente novamente mais tarde.", error);
                console.error("Erro ao exportar PDF:", error);
                setLoading(false);
            });
    }

    function handleGetAlbumByEmpresaId(empresaId: number): Promise<PreparacaoAlbumType[] | null> {
            setLoading(true);
            return api
                .get(`/PreparacaoAlbum/getAlbumByEmpresaId/${empresaId}`)
                .then((response) => {
                    const album: PreparacaoAlbumType[] = response.data;
                    setListPreparacaoAlbum(album);
                    setLoading(false);
                    return album;
                })
                .catch((error) => {
                    if (error?.response?.status === 401) {
                        handleLogout();
                        showToast(
                            "error",
                            "Sessão desconectada. Favor login novamente.",
                            error
                        );
                    } else {
                        showToast(
                            "error",
                            "Erro ao buscar informações do curso. Verifique novamente mais tarde.",
                            error
                        );
                    }
                    setLoading(false);
                    console.error("Erro ao buscar informações do curso:", error);
                    return null;
                });
        }

    return {
        preparacaoAlbum,
        listPreparacaoAlbum,
        preparacaoAlbumPageCount,
        initialListPreparacaoAlbum,
        createPreparacaoAlbum,
        getPreparacaoAlbumPaged,
        updatePreparacaoAlbum,
        deletePreparacaoAlbum,
        handleGetPreparacaoAlbumById,
        setPreparacaoAlbum,
        setListPreparacaoAlbum,
        setPreparacaoAlbumPageCount,
        updateStatusPreparacaoAlbum,
        exportPreparacaoAlbumPdf,
        handleGetAlbumByEmpresaId,
    };
}
